import { render, staticRenderFns } from "./SettingFormsPage.vue?vue&type=template&id=12627a1c"
import script from "./SettingFormsPage.vue?vue&type=script&lang=js"
export * from "./SettingFormsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingFormsPage.vue?vue&type=style&index=0&id=12627a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports